import { Component, Inject, OnInit } from '@angular/core';
import { FrontUserService } from '../../../../core/services/frontUsers.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {concatMap, finalize, from} from 'rxjs';
import {EventsService} from '../../../../core/services/events.service';
import moment from 'moment';

const DATE_DIVIDERS: Record<string, string> = {
  oneDay: ',',
  longEvent: '-',
  fewDays: '/',
  repeatEvent: ',',
  default: ','
};

@Component({
    selector: 'book-event-modal',
    templateUrl: './book-event.component.html',
    styleUrls: ['./book-event.component.scss'],
    standalone: false,
  providers: [EventsService]
})

export class BookEventComponent implements OnInit{

  events = [];
  selectedEvent;
  selectedEventData;
  users;
  usersStr = '';
  result = [];
  checkAllDates = false;
  showOlderEvents = false;
  selectedDate;
  loading = false;

  constructor(public eventsService: EventsService, public frontUserService: FrontUserService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<BookEventComponent>) {
    this.users = data;
    if (this.users.length) {
      this.users.forEach(el => {
        this.usersStr = this.usersStr + el.firstName + ' ' + el.lastName + ', ';
      });
    }
    this.usersStr = this.usersStr.substring(0, this.usersStr.length - 2);
  }

  ngOnInit() {
    this.getEvents();
  }

  changeShowAll() {
    this.getEvents();
  }

  chooseEvent() {
    this.selectedEventData = Object.assign({}, this.events.find(x => x.id === this.selectedEvent.id));
    if (this.selectedEventData && this.selectedEventData.allDates) {
      this.selectedEventData.allDates = this.selectedEventData.allDates.split(',').join(', ');
    }
    this.checkAllDates = false;
  }

  getEvents() {
    this.loading = true;
    this.eventsService.getEvents(1, 1000, '', '', '', false,
      false, false, '', this.showOlderEvents)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((res: any) => {
        if (res) {
          this.events = res.events.map(event => this.formatEvent(event));
          console.log(this.events);
        }
      });
  }

  private formatEvent(event: any) {
    const divider = DATE_DIVIDERS[event.datesType] ?? DATE_DIVIDERS.default;
    const dateStrings = event.eventDates || [];
    const sortedData = dateStrings.sort((a, b) => a.date.localeCompare(b.date));
    const dates = sortedData
      .map(d => moment(new Date(d.date)).format('DD.MM.YYYY'))
      .join(divider);

    return {
      ...event,
      dates
    };
  }

  startBooking() {
    if (this.users && this.users.length) {
      let date = this.selectedEvent.dates.replace(/\//g, ',');
      if (this.selectedEvent?.datesType === 'oneDay' && this.selectedEvent?.eventDates?.length > 1) {
        date = moment(new Date(this.selectedDate)).format('DD.MM.YYYY');
      }
      if (this.checkAllDates) {
        date = this.events.find(x => x.id === this.selectedEvent.id).allDates;
      }
      this.loading = true;
      from(this.users)
        .pipe(
          concatMap(el => {
            const data: any = {
              user: el,
              date: date.trim(),
              eventId: this.selectedEvent.id
            };
            return this.frontUserService.bookEvent(data);
          }),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((res: any) => {
          if (res) {
            const user = res.user;
            if (res.msg === 'alreadyBooked') {
              this.result.push({user: user.firstName + ' ' + user.lastName, msg: 'already_booked', type: 'ok'});
            }
            if (res.msg === 'booked') {
              this.result.push({user: user.firstName + ' ' + user.lastName, msg: 'booked', type: 'ok'});
            }
            if (res.msg === 'no valid TG') {
              this.result.push({user: user.firstName + ' ' + user.lastName, msg: 'no_valid_TG', type: 'error'});
            }
            if (res.msg === 'no valid Level') {
              this.result.push({user: user.firstName + ' ' + user.lastName, msg: 'no_valid_level', type: 'error'});
            }
            if (res.msg === 'waitList') {
              this.result.push({user: user.firstName + ' ' + user.lastName, msg: 'add_to_waitlist', type: 'warning'});
            }
            if (res.msg === 'noPlaces') {
              this.result.push({user: user.firstName + ' ' + user.lastName, msg: 'noPlaces', type: 'warning'});
            }
          }
        });
    }
  }

  get selectedEventValidDate() {
    return this.selectedEvent?.datesType === 'oneDay' && this.selectedEvent?.eventDates?.length > 1 && !this.selectedDate;

  }
}
